import { Tooltip } from "@mui/material";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useState } from "react";

export const LockButton = (
  props: MuiButtonProps & {
    tooltip?: string;
    lock: boolean;
    onChange: (value: boolean) => void;
  }
) => {
  const [isLocked, setIsLocked] = useState<boolean>(props.lock || true);

  const handleLock = () => {
    setIsLocked(!isLocked);
    props.onChange(!isLocked);
  }

  return (
    <Tooltip title={props.tooltip}>
      <>
        {!isLocked && (<LockOpenIcon style={{ cursor: "pointer" }} onClick={() => handleLock()} />)}
        {isLocked && (<LockIcon style={{ cursor: "pointer" }} onClick={() => handleLock()} />)}
      </>
    </Tooltip>
  );
};